import type { TaskOptionsInitResponse } from "@/types/init";
import type { AxiosRequestConfig } from "axios";
import { get } from "lodash-es";

export function useConfigurationInitialize(overrides?: AxiosRequestConfig) {
  const { setCachedData, maybeGetFromCacheAndRefetch } = useApiCache();
  const request = useQuery({
    queryKey: ["initialize"],
    queryFn: async () => {
      const { cachedData, isInitialized } = maybeGetFromCacheAndRefetch("initData", [
        "initialize",
      ]);
      if (cachedData?.tasks && !isInitialized) return cachedData;
      const response = await useGetRequest<TaskOptionsInitResponse>(
        "/initialize",
        overrides
      );

      const data = get(response, "data", null);
      if (data) {
        setCachedData("initData", data);
      }
      return get(response, "data", null);
    },
    staleTime: 1 * MINUTE,
    enabled: !!currentSessionInformation.appAuthToken,
  });
  return request;
}
